<template>
  <div ref="cookieBotContainer"></div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CookieBot extends Vue {
  @Prop({ type: String }) protected token!: string | undefined;

  get scriptSrc(): string | undefined {
    return this.token ? `https://consent.cookiebot.com/${this.token}/cd.js` : undefined;
  }

  protected mounted() {
    if (!this.token || !this.scriptSrc) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('src', this.scriptSrc);
    script.setAttribute('async', '');
    script.setAttribute('id', 'CookieDeclaration');

    const container = this.$refs.cookieBotContainer as HTMLDivElement | null;
    if (container) {
      container.appendChild(script);
    }
  }
}
</script>
